var _path, _mask, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgNewCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.417 33.875c-4.113 0-7.459-3.346-7.459-7.458 0-4.113 3.346-7.459 7.459-7.459 4.112 0 7.458 3.347 7.458 7.459s-3.346 7.458-7.458 7.458zm0-13.416a5.965 5.965 0 0 0-5.959 5.958 5.965 5.965 0 0 0 5.959 5.958 5.965 5.965 0 0 0 5.958-5.958 5.965 5.965 0 0 0-5.958-5.959z",
    fill: "#8C8C8E",
    stroke: "#fff",
    strokeWidth: 0.25
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "74z155ezla",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.542 29.625a.875.875 0 0 0 1.75 0v-2.333h2.333a.875.875 0 0 0 0-1.75h-2.333v-2.334a.875.875 0 0 0-1.75 0v2.334h-2.334a.875.875 0 0 0 0 1.75h2.334v2.333z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.542 29.625a.875.875 0 0 0 1.75 0v-2.333h2.333a.875.875 0 0 0 0-1.75h-2.333v-2.334a.875.875 0 0 0-1.75 0v2.334h-2.334a.875.875 0 0 0 0 1.75h2.334v2.333z",
    fill: "#8C8C8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.292 27.292v-.25h-.25v.25h.25zm0-1.75h-.25v.25h.25v-.25zm-1.75 0v.25h.25v-.25h-.25zm0 1.75h.25v-.25h-.25v.25zm.875 2.958a.625.625 0 0 1-.625-.625h-.5c0 .621.504 1.125 1.125 1.125v-.5zm.625-.625c0 .345-.28.625-.625.625v.5c.62 0 1.125-.504 1.125-1.125h-.5zm0-2.333v2.333h.5v-2.333h-.5zm2.583-.25h-2.333v.5h2.333v-.5zm.625-.625c0 .345-.28.625-.625.625v.5c.621 0 1.125-.504 1.125-1.125h-.5zm-.625-.625c.345 0 .625.28.625.625h.5c0-.621-.504-1.125-1.125-1.125v.5zm-2.333 0h2.333v-.5h-2.333v.5zm-.25-2.584v2.334h.5v-2.334h-.5zm-.625-.624c.345 0 .625.28.625.625h.5c0-.622-.504-1.125-1.125-1.125v.5zm-.625.625c0-.345.28-.625.625-.625v-.5c-.621 0-1.125.503-1.125 1.125h.5zm0 2.333v-2.334h-.5v2.334h.5zm-2.584.25h2.334v-.5h-2.334v.5zm-.625.625c0-.345.28-.625.625-.625v-.5c-.62 0-1.125.504-1.125 1.125h.5zm.625.625a.625.625 0 0 1-.625-.625h-.5c0 .62.504 1.125 1.125 1.125v-.5zm2.334 0h-2.334v.5h2.334v-.5zm.25 2.583v-2.333h-.5v2.333h.5z",
    fill: "#fff",
    mask: "url(#74z155ezla)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.722 30.375H9.208a3.086 3.086 0 0 1-3.083-3.083V9.208c0-1.7 1.383-3.083 3.083-3.083h13.417c1.7 0 3.083 1.383 3.083 3.083v7.105a.75.75 0 0 1-1.5 0V9.208c0-.873-.71-1.583-1.583-1.583H9.208c-.873 0-1.583.71-1.583 1.583v18.084c0 .872.71 1.583 1.583 1.583h7.514a.75.75 0 0 1 0 1.5z",
    fill: "#8C8C8E",
    stroke: "#fff",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.458 16.959H10.375a.75.75 0 0 1 0-1.5h11.083a.75.75 0 0 1 0 1.5zM16.792 21.625h-6.417a.75.75 0 0 1 0-1.5h6.417a.75.75 0 0 1 0 1.5zM15.625 12.291h-5.25a.75.75 0 0 1 0-1.5h5.25a.75.75 0 0 1 0 1.5z",
    fill: "#8C8C8E",
    stroke: "#fff",
    strokeWidth: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCampaign);
export default __webpack_public_path__ + "static/media/new-campaign.9cabc919917f68d6a477a29393925d81.svg";
export { ForwardRef as ReactComponent };